import http from '@/libs/http'
export default class FacturaNumeroService {
  getFacturaNumero () {
    return http.get(`${process.env.VUE_APP_MICROSERVICE_API_FACTURACION}/factura_numero`)
  }
}
